enum AppRoutes {
  Home = '/',
}

export default AppRoutes;
